import FreighterApi from "@/api/delivery/freighterApi";
export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch} , form) {
      try {
        const response = await FreighterApi.addOrUpdate(form);
        await dispatch('NOTIFY_MSG', 'delivery.notifications.savedFreighter', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async changeSelf({dispatch} , form) {
      try {
        const response = await FreighterApi.changeSelf(form);
        await dispatch('NOTIFY_MSG', 'delivery.notifications.savedFreighter', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch({dispatch} , {id, fetchFromTransport}) {
      try {
        const response = await FreighterApi.fetch(id, fetchFromTransport);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
